import { render } from "./RiskManagement.vue?vue&type=template&id=de1cdc00&scoped=true"
import script from "./RiskManagement.vue?vue&type=script&lang=ts"
export * from "./RiskManagement.vue?vue&type=script&lang=ts"

import "./RiskManagement.vue?vue&type=style&index=0&id=de1cdc00&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-de1cdc00"

export default script